import { template as compile } from "lodash-es";

export class TemplateService {
  static compile(template: string, data: any) {
    return compile(template)(data);
  }
}
